/**
 * НЕСОХРАНЁННАЯ РАБОТА, КОТОРУЮ НЕ ВИДНО ПО ПОЛЯМ ВВОДА.
 *
 * Вкладка обновляется сама в безопасный момент (правило 211), и безопасным
 * он считался, пока ничего не набрано в поля. Холст набирается КАСАНИЯМИ, а
 * не вводом: начерченная комната выглядела «ничего не набрано», и через
 * минуту без движения — замерщик меряет рулеткой — или когда камера «Снять
 * лист» прятала вкладку, страница перезагружалась вместе с чертежом. Экран с
 * такой работой отмечается здесь сам, и перезагрузка её ждёт.
 */
const holders = new Set<string>();

export function markUnsaved(key: string, unsaved: boolean): void {
  if (unsaved) holders.add(key);
  else holders.delete(key);
}

export function hasUnsavedWork(): boolean {
  return holders.size > 0;
}
